module.exports = __webpack_public_path__ + "img/3_27.604a17d0.png";